export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/breadcrumb-arrow.4551cf0f-86315a.svg";